import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { voucherAPI } from '../services/api';
import './RedeemVoucher.css';

const RedeemVoucher = () => {
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(null);
  const navigate = useNavigate();

  const formatVoucherCode = (value) => {
    // Remove all non-alphanumeric characters
    const cleaned = value.toUpperCase().replace(/[^A-Z0-9]/g, '');
    
    // Add dashes every 4 characters
    const parts = [];
    for (let i = 0; i < cleaned.length; i += 4) {
      parts.push(cleaned.substring(i, i + 4));
    }
    
    return parts.join('-');
  };

  const handleCodeChange = (e) => {
    const formatted = formatVoucherCode(e.target.value);
    setCode(formatted);
    setError('');
  };

  const handleRedeem = async (e) => {
    e.preventDefault();
    
    if (!code || code.length < 15) {
      setError('Please enter a valid voucher code');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const response = await voucherAPI.redeemVoucher(code);
      
      if (response.data.success) {
        setSuccess(response.data);
        setTimeout(() => {
          navigate('/inbox');
        }, 3000);
      } else {
        setError(response.data.message || 'Failed to redeem voucher');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Invalid voucher code');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="redeem-voucher-container">
      <div className="redeem-voucher-card">
        <div className="voucher-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="2" y="7" width="20" height="10" rx="2" />
            <path d="M2 12h20" />
            <circle cx="7" cy="12" r="1" fill="currentColor" />
            <circle cx="17" cy="12" r="1" fill="currentColor" />
          </svg>
        </div>

        <h1>Redeem Voucher</h1>
        <p className="voucher-subtitle">
          Enter your voucher code to add credits to your account
        </p>

        {success ? (
          <div className="success-message">
            <div className="success-icon">✓</div>
            <h2>Success!</h2>
            <p className="credits-added">
              +{success.creditsAdded} Credits
            </p>
            <p className="new-balance">
              New Balance: {success.newBalance} credits
            </p>
            <p className="redirect-message">
              Redirecting to inbox...
            </p>
          </div>
        ) : (
          <form onSubmit={handleRedeem} className="voucher-form">
            <div className="form-group">
              <label htmlFor="voucherCode">Voucher Code</label>
              <input
                type="text"
                id="voucherCode"
                value={code}
                onChange={handleCodeChange}
                placeholder="KWIK-XXXX-XXXX-XXXX"
                maxLength={19}
                className="voucher-input"
                disabled={loading}
              />
              <p className="input-hint">
                Enter the code from your voucher card
              </p>
            </div>

            {error && (
              <div className="error-message">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="12" r="10" />
                  <line x1="12" y1="8" x2="12" y2="12" />
                  <line x1="12" y1="16" x2="12.01" y2="16" />
                </svg>
                {error}
              </div>
            )}

            <button 
              type="submit" 
              className="btn-redeem"
              disabled={loading || !code}
            >
              {loading ? 'Redeeming...' : 'Redeem Voucher'}
            </button>
          </form>
        )}

        <div className="voucher-info">
          <h3>Where to buy vouchers?</h3>
          <ul>
            <li>Available at selected retailers</li>
            <li>Online through our website</li>
            <li>Contact support for bulk purchases</li>
          </ul>
          
          <div className="voucher-packages">
            <div className="package-info">
              <span className="package-value">R10</span>
              <span className="package-credits">10 Credits</span>
            </div>
            <div className="package-info">
              <span className="package-value">R25</span>
              <span className="package-credits">25 Credits</span>
            </div>
            <div className="package-info">
              <span className="package-value">R50</span>
              <span className="package-credits">50 Credits</span>
            </div>
            <div className="package-info">
              <span className="package-value">R100</span>
              <span className="package-credits">100 Credits</span>
            </div>
          </div>
        </div>

        <button 
          className="btn-back"
          onClick={() => navigate('/inbox')}
        >
          Back to Inbox
        </button>
      </div>
    </div>
  );
};

export default RedeemVoucher;
